import {CompanyEntity, CompanySelectorProps, companyType} from "@ots-frontend/ots-data";
import {CompanySelect, CompanySelectProps} from "./CompanySelect";
import {Box, Button, Modal, ModalProps} from "@mantine/core";
import {useState} from "react";
import {useTranslation} from "react-i18next";

type Props = Omit<CompanySelectProps, "selector"> & {
    selector?: Omit<CompanySelectorProps, "companyType">
};

export const VendorCompanySelect = (props: Props) => {
    const {selector, ...rest} = props;

    return (
        <CompanySelect
            {...rest}
            selector={{
                ...selector,
                companyType: companyType.vendor
            }}/>
    );
};

export interface VendorCompanySelectModalProps extends Omit<ModalProps, "onSubmit"> {
    select?: Props,
    onSubmit?: (companies: CompanyEntity[] | undefined) => void
}

export const VendorCompanySelectModal = (props: VendorCompanySelectModalProps) => {
    const {
        select,
        onSubmit,
        ...rest
    } = props;

    const [selectedCompanies, setSelectedCompanies] = useState<CompanyEntity[]>([])

    const {t} = useTranslation(["common"]);

    return (
        <Modal {...rest}>
            <Box>
                <VendorCompanySelect
                    {...select}
                    onEntityChange={e => setSelectedCompanies(e)}/>
                <Button type="submit" mt="xl" onClick={(e) => {
                    if (onSubmit) {
                        onSubmit(selectedCompanies);
                    }
                }}>
                    {t("common.action.submit")}
                </Button>
            </Box>
        </Modal>
    );
};
